import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Spin } from "antd";

import globalColors from "../../styles/globalColors";

type Props = {
  color: string;
  title: string;
  value: string | number;
  linkText?: string;
  loading: boolean;
  onPress: () => void;
};

const DashboardInfoColorBox: React.FC<Props> = ({
  color,
  title,
  value,
  linkText,
  loading,
  onPress
}) => {
  return (
    <div
      css={[styles.container, { borderTopColor: color }]}
      onClick={() => onPress()}
    >
      <p css={styles.title}>{title.toUpperCase()}</p>
      <div css={styles.value}>{loading ? <Spin /> : value}</div>
      {linkText && <p css={styles.link}>{linkText}</p>}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#eee",
    borderTop: "15px solid #999",
    boxShadow: "none",
    color: "#333",
    cursor: "pointer",
    width: 180,
    height: 160,
    padding: 10,
    textAlign: "center" as "center"
  },
  link: {
    color: globalColors.textBlue,
    fontSize: 13,
    marginBottom: 0
  },
  title: {
    color: globalColors.textGray,
    fontSize: 15,
    fontWeight: 600,
    height: 50
  },
  value: {
    color: globalColors.textBlue,
    fontSize: 43,
    lineHeight: "39px"
  }
};

export default DashboardInfoColorBox;
